import { render } from "./acercaDe.vue?vue&type=template&id=8f7a0e24&scoped=true"
import script from "./acercaDe.vue?vue&type=script&lang=js"
export * from "./acercaDe.vue?vue&type=script&lang=js"

import "./acercaDe.vue?vue&type=style&index=0&id=8f7a0e24&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f7a0e24"]])

export default __exports__